import { X } from 'lucide-react'

interface ReadMoreModalProps {
  title: string
  description?: string
  longFormDescriptor?: string
  isOpen: boolean
  onClose: () => void
}

export const ReadMoreModal = ({ title, longFormDescriptor, isOpen, onClose }: ReadMoreModalProps) => {
  if (!isOpen) return null

  return (
    <div className='fixed inset-0 bg-black/30 flex items-center justify-center z-50 p-4'>
      <div className='bg-white rounded-lg w-full max-w-[681px] max-h-[90vh] overflow-hidden flex flex-col min-h-0' style={{ boxShadow: '0 17px 20px 0 rgba(0,0,0,0.25)' }}>
        {/* Header */}
        <div className='flex items-center justify-between px-5 h-[67px] bg-[var(--color-curtin-primary-background)] shrink-0'>
          <span />
          <button onClick={onClose} className='p-1 rounded hover:bg-[var(--color-grey-200)]' title='Close'>
            <X className='w-5 h-5 text-[var(--color-grey-600)]' />
          </button>
        </div>

        {/* Content */}
        <div className='grow overflow-y-auto px-[46px] pt-[46px] pb-[85px] flex flex-col gap-[34px]'>
          {/* Title */}
          <h1 className='text-[28px] font-bold leading-9 text-[var(--color-curtin-secondary-black-100)] [font-family:var(--font-effra)]'>{title}</h1>

          {/* Description Section */}
          <div>
            <h2 className='text-lg font-bold leading-7 text-[var(--color-curtin-secondary-black-100)] [font-family:var(--font-proxima-nova)] mb-3'>Description</h2>
            <p className='text-lg font-normal leading-7 text-[var(--color-curtin-primary-black-90)] [font-family:var(--font-proxima-nova)] whitespace-pre-wrap'>{longFormDescriptor}</p>
          </div>
        </div>
      </div>
    </div>
  )
}
